import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  inject,
  Injector,
  input,
  Input,
  Output
} from '@angular/core';
import {AbstractValueAccessorComponent} from "../../../../../../../../common/component/value-accessor.component";
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {UnitOfMass} from "../../../../../../types";

@Component({
  selector: 'app-cargo-weight',
  templateUrl: './cargo-weight.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cargo-weight.component.scss',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CargoWeightComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CargoWeightComponent), multi: true }
  ],
  standalone: false
})
export class CargoWeightComponent extends AbstractValueAccessorComponent<number | null> implements Validator {
  readonly injector = inject(Injector);
  readonly wrapError = input(true);
  @Input() weight: number | null;
  @Input() unitOfMass: UnitOfMass = UnitOfMass.KILOGRAM;
  @Output() weightChanged = new EventEmitter<number>();

  value: number | null = null;
  displayValue: string = '';

  get control() {
    return this.injector.get(NgControl, null)?.control;
  }

  writeValue(value: number | null): void {
    this.value = value;

    this.displayValue = value == null
      ? ''
      : String(value / 1000)
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.value === '') {
      this.value = null;
      this.onChangeCallback(null);
      return;
    }

    const actualValue = Number(input.value) * 1000;
    this.value = actualValue;
    this.onChangeCallback(actualValue);
  }

  validate(_: AbstractControl): ValidationErrors | null {
    if (this.value == null) {
      return { required: true };
    }

    if (this.value <= 0) {
      return { min: { min: 1, actual: this.value } };
    }

    if (this.value >= 1000000000) {
      return { max: { max: 999999999, actual: this.value } };
    }

    return null;
  }
}
